export const apiName: string = 'ordens-servicos';
export const ordensServicoRoute: string = 'ordens-servico';
export const ordensServicoItemsServicoRoute: string = 'servico';
export const ordensServicoItemsMaterialRoute: string = 'material';
export const ordensServicoStorage: string = 'ordens-servico';
export const ordensServicoItemsStorage: string = 'ordens-servico-itens';
export const ordensServicoModuleName: any = {plural: 'Manutenções', single: 'Manutenção'};

export const OrdemServicoStatus: any = [
    { Key: 1, Value: "Ativo" },
    { Key: 2, Value: "Concluído" },
    { Key: 3, Value: "Cancelado" }
];

export const TipoOrdemServico: any = [
    { Key: 2, Value: "Preventiva" },
    { Key: 1, Value: "Corretiva" }
];

export const TipoMaterialServico: any = [
    { Key: 2, Value: "Material" },
    { Key: 1, Value: "Serviço" }
];

// export const ordemServicoQueryMateriaisServicos: any = {"where":{"ativo":true,"descricao":{"regexp":"/REPLACEHERE/i"}}};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/shared/data.service.ts
 **/